import Axios, { Method } from 'axios';
import { URL } from '../enum';

/**
 * AxiouUtils
 */
export default class AxiosUtils {
  /**
   * API GET 呼び出し
   * @param {string} url
   * @param {any} params
   * @return {T} response
   */
  public static async accessGet<T>(url: string, params: any): Promise<T> {
    return await this.apiAccess<T>(url, params, 'GET');
  }

  /**
   * API POST 呼び出し
   * @param {string} url
   * @param {any} params
   * @return {T} response
   */
  public static async accessPost<T>(url: string, params: any): Promise<T> {
    return await this.apiAccess<T>(url, params, 'POST');
  }

  /**
   * ServerAPIにアクセスする
   * @param url url
   * @param params パラメータ
   * @param method メソッド名
   */
  private static async apiAccess<T>(
    url: string,
    params: any,
    method: string
  ): Promise<T> {
    try {
      const response = await Axios({
        method: method as Method,
        url: URL.BaseURL + '/' + url,
        data: JSON.stringify(params),
        headers: {
          'Content-Type': 'application/json',
        },
        responseType: 'json',
      });
      if (response.status === 200) {
        return response.data as T;
      } else {
        // APIのアクセスエラー
        const error = `api access error : ${URL.BaseURL}${url}`;
        console.log(`${response.data}`);
        throw new Error(`${error}`);
      }
    } catch (e) {
      console.log(e);
      throw e;
    }
  }
}
